import AuthActions from '../actions/authActions';
// import * as firebase from 'firebase';
import axios from 'axios';
import Path from '../../config/path';

class AuthMiddleware {

    // static signinMiddleware(email, password) {
    //     return dispatch => {
    //         firebase.auth().signInWithEmailAndPassword(email, password).then((data) => {
    //             dispatch(AuthActions.Signin(data))
    //             console.log(data);
    //         }).catch((error) => {
    //             console.log(error);
    //         })
    //     };
    // }

    // static signupMiddleware(firstName, lastName, email, password) {
    //     console.log(firstName, lastName, email, password, "middleware")
    //     return dispatch => {
    //         axios.post(`${Path.baseUrl}/signup`, {
    //             firstName : firstName,
    //             lastName : lastName,
    //             email : email,
    //             password : password
    //         }).then((response) => {
    //             console.log(response)
    //             dispatch(AuthActions.Signup(response.data))
    //         }).catch(err => {
    //             console.log(err)
    //         })
    //     };
    // }

    // static logoutMiddleware() {
    //     return dispatch => {
    //         firebase.auth().signOut().then(() => {
    //             dispatch(AuthActions.Logout())
    //         })
    //     };
    // }

    static manualSignInMiddleware(email, password) {
        return dispatch => {
            axios.post(`${Path.baseUrl}/signin/${new Date().getTime()}`, {
                email : email,
                password : password
            }).then((response) => {
                if (response.data.error) {
                    dispatch(AuthActions.SigninFailed(response.data))
                }
                else {
                    dispatch(AuthActions.Signin(response.data))
                }
            }).catch(err => {
                console.log(err)
            })
        }
    }

    static fbsigninMiddleware() {
        return dispatch => {
            function statusChangeCallback(response, res) {
                dispatch(AuthMiddleware.accessTokenMiddleware(response, res))
            }
            window.FB.login(
                function (resp) {
                    window.FB.api('/me?fields=email,name,first_name,last_name', function (response) {
                        statusChangeCallback(resp, response);
                    })
                }.bind(this), { scope: 'email,public_profile' });
        }
    }
    static accessTokenMiddleware(response, res) {
        return dispatch => {
            if (response.status === 'connected') {
                axios.post(Path.LOGIN, {
                    isRegister: true,
                    service: "facebook",
                    authData: response,
                    userInfo:res
                }).then((responseUser) => {
                    dispatch(AuthActions.FbSignin(responseUser.data))
                }).catch(err => { 
                    // console.log(err)
                 })
            }
            else if (response.status === 'not_authorized') {
                dispatch(AuthActions.FbSigninFailed())
                // console.log('Import error', 'Authorize app to import data', 'error')
            } else {
                dispatch(AuthActions.FbSigninFailed())
                // console.log('Import error', 'Error occured while importing data', 'error')
            }
        }
    }
    static fblogoutMiddleware() {
        return dispatch => {
            window.FB.logout(
                function (response) {
                    dispatch(AuthActions.FbLogout())
                });
        };
    }

    static updateprofileMiddleware(data) {
        return dispatch => {
            axios.post(`${Path.UPDATE}${data.id}/panacloudId/${data.panaCloud_id}/registerpanacloudId?userId=${data.id}&panacloudId=${data.panaCloud_id}`, {
                isRegister: true
            }

            ).then((response) => {
                if (response.data.error) {
                    dispatch(AuthActions.UpdateFailed())
                }
                else {
                    dispatch(AuthActions.UpdateProfile({ data: data.panaCloud_id }))
                }
            }
            ).catch(err => {
            //  console.log(err)
            })
        }
    }
}

export default AuthMiddleware;


// WEBPACK FOOTER //
// ./src/store/middleware/authMiddleware.js